import ScriptsLoader from "./ScriptsLoader"

export default  ScriptsLoader;



// WEBPACK FOOTER //
// ./src/components/App/ScriptsLoader/index.js